var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHaynesPro = function SvgHaynesPro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 84 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.354 22.165V.085h18.423v59.98H46.354V36.722H32.291v23.345H13.868V.086H32.29v22.08zM83.35 74.621C42.136 73.988.34 79.405.34 79.405v-9.849c41.358-6.682 83.008-6.753 83.008-6.753z",
    clipRule: "evenodd"
  })));
};
export { SvgHaynesPro as ReactComponent };
export default __webpack_public_path__ + "084fb8da77a08d518877f9707466dbd7.svg";